module.exports = __webpack_public_path__ + "media/spokesperson.acfc7ea3.mp4";